import { stringValidator } from '#validation/common/validators';
export const storageSecretAccessKeyValidator = stringValidator({
    requiredError: 'internal.key.required',
});
